const dev = {
    // API_ENDPOINT_URL: 'http://localhost:5000/dealer_panel_api',
  // API_FILE_PATH_URL : `http://localhost:5000/files`,
  //  API_ENDPOINT_URL: "http://31.220.96.248:5000/dealer_panel_api",
  // API_FILE_PATH_URL: "http://31.220.96.248:5000/files",
  // RO_FILE_PATH_URL: "http://31.220.96.248:5001/public/IMAGES",

   API_ENDPOINT_URL: "https://dma.mahanagargas.com:5000/dealer_panel_api",
  API_FILE_PATH_URL: "https://dma.mahanagargas.com:5000/files",
  RO_FILE_PATH_URL: "https://dma.mahanagargas.com:5001/public/IMAGES",
};


const getEnv = () => {
return dev
}

export const env = getEnv()
